// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5f9a849","821":"5445931d"}[chunkId] + ".chunk.js";
};